// extracted by mini-css-extract-plugin
export default {"container":"xT8YaRaTXwXYcJ3stNLk","btn":"jjVKdHlBxC2apVVWtSdR","portraitTitle":"vXCCQ6DbBH8U59peuroS","apptCard":"wkWcO9BTS3h73ui8FmA_","apptCardContent":"UWqDoFvMBSfKBMIdOfEq"};